"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDashboardLayoutSection = exports.isDashboardLayout = exports.isDashboardLayoutItem = exports.isDashboardWidget = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var isArray_1 = tslib_1.__importDefault(require("lodash/isArray"));
var widget_1 = require("./widget");
/**
 * Type-guard testing whether the provided object is an instance of {@link IDashboardWidget}.
 * @alpha
 */
exports.isDashboardWidget = function (obj) {
    return [isDashboardLayout, widget_1.isWidget, widget_1.isWidgetDefinition].some(function (guard) { return guard(obj); });
};
/**
 * Type-guard testing whether the provided object is an instance of {@link IDashboardLayoutItem}.
 * @alpha
 */
function isDashboardLayoutItem(obj) {
    var _a, _b;
    return !isEmpty_1.default(obj) && typeof ((_b = (_a = obj.size) === null || _a === void 0 ? void 0 : _a.xl) === null || _b === void 0 ? void 0 : _b.gridWidth) === "number";
}
exports.isDashboardLayoutItem = isDashboardLayoutItem;
/**
 * Type-guard testing whether the provided object is an instance of {@link IDashboardLayout}.
 * @alpha
 */
function isDashboardLayout(obj) {
    return !isEmpty_1.default(obj) && obj.type === "IDashboardLayout";
}
exports.isDashboardLayout = isDashboardLayout;
/**
 * Type-guard testing whether the provided object is an instance of {@link IDashboardLayoutSection}.
 * @alpha
 */
function isDashboardLayoutSection(obj) {
    return !isEmpty_1.default(obj) && isArray_1.default(obj.items);
}
exports.isDashboardLayoutSection = isDashboardLayoutSection;
//# sourceMappingURL=layout.js.map